module.exports = __webpack_public_path__ + "img/xzht2.280ed717.png";